/**
 * Who a LiveKit participant in a moderator's room is, by the identity the
 * token service gives them (ai/diagrams/voice-chat-transcription.md): a
 * player in a private call (`player_…`), a moderator monitoring a team's room
 * (`ponder_moderator_…`), or the transcription agent (`agent-…`). The two
 * windows spelled the prefixes at each of eight uses.
 */

/**
 * How the identity the server gives the player of a private call begins
 * (shared/livekit.go: PrivateChatPlayerIdentityPrefix, which
 * client_parity_test.go holds this to).
 */
const PRIVATE_CALL_PLAYER_PREFIX = 'player_';

/** The player of a private call. */
export const isPlayerIdentity = (identity: string) => identity.startsWith(PRIVATE_CALL_PLAYER_PREFIX);

/** A moderator in a team's room: the monitor marks their transcripts and their name. */
export const isModeratorIdentity = (identity: string) => identity.startsWith('ponder_moderator_');

/** The transcription agent, which the monitor neither lists nor transcribes. */
export const isAgentIdentity = (identity: string) => identity.startsWith('agent-');
